import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { Input, Label, Text } from 'components';
import CountrySelector from 'pages/ContactUs/CountrySelector';

interface Props {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  company: string;
  country: any;
  purpose: string;
  setEmail: React.Dispatch<React.SetStateAction<string>>;
  setPassword: React.Dispatch<React.SetStateAction<string>>;
  setFirstName: React.Dispatch<React.SetStateAction<string>>;
  setLastName: React.Dispatch<React.SetStateAction<string>>;
  setCompany: React.Dispatch<React.SetStateAction<string>>;
  setCountry: React.Dispatch<React.SetStateAction<any>>;
  setPurpose: React.Dispatch<React.SetStateAction<string>>;
  onEmailBlur: () => void;
  onPasswordBlur: () => void;
  onNameBlur: () => void;
  onCompanyBlur: () => void;
  onCountryBlur: () => void;
  emailError: string;
  passwordError: string;
  nameError: string;
  companyError: string;
  countryError: string;
}

const EmailPasswordForm = ({
  email,
  password,
  firstName,
  lastName,
  company,
  country,
  purpose,
  setEmail,
  setPassword,
  setFirstName,
  setLastName,
  setCompany,
  setPurpose,
  setCountry,
  onEmailBlur,
  onPasswordBlur,
  onNameBlur,
  onCompanyBlur,
  onCountryBlur,
  emailError,
  passwordError,
  nameError,
  companyError,
  countryError,
}: Props) => {
  const handleCountryChange = (selectedCountry: any) => {
    setCountry(selectedCountry);
  };

  return (
    <form className="mb-6 flex w-full flex-col gap-6">
      <Input
        inputClassName="bg-white h-10"
        label="Email"
        type="text"
        value={email}
        setValue={setEmail}
        onBlur={onEmailBlur}
        errorMessage={emailError}
      />
      <Input
        inputClassName="bg-white h-10"
        label="Password"
        type="password"
        value={password}
        setValue={setPassword}
        onBlur={onPasswordBlur}
        errorMessage={passwordError}
      />
      <div className="flex gap-4">
        <Input
          inputClassName="bg-white h-10"
          label="First Name"
          type="text"
          value={firstName}
          setValue={setFirstName}
          onBlur={onNameBlur}
          errorMessage={nameError}
        />
        <Input
          inputClassName="bg-white h-10"
          label="Last Name"
          type="text"
          value={lastName}
          setValue={setLastName}
          onBlur={onNameBlur}
          errorMessage={nameError}
        />
      </div>
      <Input
        inputClassName="bg-white h-10"
        label="Company"
        type="text"
        value={company}
        setValue={setCompany}
        onBlur={onCompanyBlur}
        errorMessage={companyError}
      />
      <Input
        inputClassName="bg-white h-10"
        label="Purpose of use"
        type="text"
        value={purpose}
        setValue={setPurpose}
        placeholder="ex) Big data application"
      />
      <label className="w-full">
        <Label label="Country" htmlFor="Country" />
        <CountrySelector   
          onBlur={onCountryBlur} 
          value={country} onChange={(value) => {
          setCountry(value);
          onCountryBlur();
        }} />
        {countryError && (
          <Text className="mt-2 !text-red-500" size="body2" weight="regular">
            {countryError}
          </Text>
        )}
      </label>
    </form>
  );
};

export default EmailPasswordForm;